import { render, staticRenderFns } from "./u-btn-icon-outlined-tile.vue?vue&type=template&id=5f7d2821&scoped=true&"
import script from "./u-btn-icon-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-btn-icon-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7d2821",
  null
  
)

export default component.exports